import { Http, HttpConfig } from '@ezio/http'

const config: HttpConfig = {
    url: 'https://crm.ezio.app',
    // url: 'http://localhost:3000',
    version: ''
}

class SellsyApi extends Http {
    public tokensStore = null

    public constructor(config: HttpConfig) {
        super()
        this.config = config
    }

    public async fetchContacts(clientId: string) {
        const response = await this.get('clients/' + clientId + '/contacts')
        return response
    }

    public async fetchClientParams(clientId: string, fields = ['abonnement', 'debut-abonnement']) {
        const clientParams: any = {}
        const response = await this.get('clients/' + clientId + '/params')
        response.data.forEach((p: any) => {
            if (fields.includes(p.code)) {
                clientParams[p.code] = p
            }
        })
        return clientParams
    }

    protected getRequestHeaders() {
        const headers = {
            Accept: 'application/json',
            'Cache-Control': 'no-store no-cache must-revalidate',
            'Access-Token': this.tokensStore.tokens.accessToken,
            Client: this.tokensStore.tokens.client,
            Uid: this.tokensStore.tokens.uid
        }
        return headers
    }
}

let api: SellsyApi = null

export const useSellsyAPI = () => {
    if (!api) {
        api = new SellsyApi(config)
    }
    return api
}
